import BaseType from "../BaseType";

export default class TrainingType extends BaseType {
  Name: string = "";
  SortOrder: number = 0;
  StaffOnly: boolean = false;
}
